import React from 'react';
import { TrendingUp, KeyRound, Receipt, Wrench, Scale, Users } from 'lucide-react';

const FEATURES = [
  {
    icon: TrendingUp,
    title: 'Rent Review Clause Analysis',
    desc: 'Detailed assessment of rent review mechanisms, market rent assumptions, and upward-only clauses with risk ratings.',
  },
  {
    icon: KeyRound,
    title: 'Break Clause Verification',
    desc: 'Verification that break clauses meet all conditions for enforceability under LTA 1954, including notice periods and conditions precedent.',
  },
  {
    icon: Receipt,
    title: 'Service Charge Provisions',
    desc: 'Analysis of service charge caps, sinking funds, management fees, and compliance with RICS Code of Practice.',
  },
  {
    icon: Wrench,
    title: 'Dilapidations Guidance',
    desc: 'Assessment of repair and reinstatement obligations, schedule of condition implications, and end-of-lease exposure.',
  },
  {
    icon: Scale,
    title: 'Landlord & Tenant Act 1954',
    desc: 'Full assessment of security of tenure, contracting-out procedures, and renewal rights under the 1954 Act.',
  },
  {
    icon: Users,
    title: 'Alienation & Assignment',
    desc: 'Review of assignment, subletting, and change of use provisions to ensure flexibility for your business needs.',
  },
];

export function CommercialWhatYouGet() {
  return (
    <section className="py-20 sm:py-28 bg-gray-50 bg-diagonal-lines">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16 animate-on-scroll">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">What You Get</h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            Comprehensive commercial lease analysis covering every critical area of your agreement.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((feature, i) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.title}
                className={`animate-on-scroll delay-${(i % 3) * 100 + 100} group bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-elevated-lg hover:border-gray-300 transition-all duration-300`}
              >
                <div className="w-12 h-12 bg-gray-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-emerald-600 transition-colors duration-300">
                  <Icon className="w-5 h-5 text-gray-700 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{feature.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
